import React, { useState } from "react"
import { Container, Col, Row, Carousel } from "react-bootstrap"
import "./PropertyCard.scss"
// import ScrollAnimation from "react-animate-on-scroll";
import CardList from "./CardList"
import { Link } from "@StarberryUtils";
import YouTube from 'react-youtube';
import Truncate from 'react-truncate';
import SellProduct from "../SellProduct/SellProduct"
import closeIcon from "../../../images/close.png"
import { ShowProcessedImage } from "../../common/ggfx-client/module/components/show-image";
import imageConfig from "../../../../static/images/config.json";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageModule from "../../common/Image_Module";
export const SingleProperty = (props) => {
    const property = CardList[0];
    const [isPlay, setPlay] = useState(false);
    const hit = props.hit;
    return (
        <section className={`property-card ${property?.mainClassName}`}>
            <Container>
                <Row>
                    <Col xl={6}>
                        <div className="product-card-img img-zoom">
                            {
                                props.strapi ?
                                <Carousel className="w-100">
                                    {hit?.images && hit?.images.slice(0, 4).map((img, i) => {
                                        let processedImages = JSON.stringify({});
                                        if (hit?.imagetransforms?.images_Transforms) {
                                            processedImages = hit?.imagetransforms.Images_Transforms;
                                        }
                                        return (
                                            <Carousel.Item key={i} className="w-100 position-relative" id={"prop-img"+i}>
                                                <Link className="w-100" to={`/property-${hit.searchType === "sales" ? "for-sale" : "to-rent"}/${hit.slug}-${hit.id}`}>
                                                    {/* <ImageTransform
                                                        imagename="property.images.featured"
                                                        attr={{ alt: '', class:'' }}
                                                        imagesources={img.url}
                                                        renderer="srcSet"
                                                        imagetransformresult={processedImages}
                                                    /> */}
                                                     <ImageModule 
                                                            ImageSrc={img} 
                                                            attr={{ alt: "" }} 
                                                            ggfx_results={property.ggfx_results} 
                                                            imagename="property.images.featured" 
                                                            strapi_id={property.id} 
                                                    />
                                                </Link>
                                            </Carousel.Item>
                                        )}
                                    )}
                                </Carousel> :
                                <Carousel 
  className="w-100" 
  interval={null} 
  controls={Array.isArray(hit?.images) && hit.images.length > 1}
>
                                    {hit?.images &&
                                        hit?.images.slice(0, 4).map((img, k) => (
                                            <Carousel.Item key={k} className="w-100">
                                                <div className="property-slide-image property-item">
                                                    {/* {img.srcUrl && <img src={img.srcUrl.replace("http", "https")} alt="img" />} */}
                                                    <Link className="w-100" to={`/property-${hit.searchType === "sales" ? "for-sale" : "to-rent"}/${hit.slug}-${hit.objectID}`}>
                                                        <ShowProcessedImage
                                                            images={img}
                                                            transforms={imageConfig.property.images.searchResults.sizes}
                                                        />
                                                    </Link>
                                                </div>
                                            </Carousel.Item>
                                        )
                                    )}
                                </Carousel>
                            }
                            {hit.virtual_tour && <div className="product-btn prop-card-play-btn" >
                                <strong className="video-btn" onClick={e => {setPlay(true)}}>
                                <i className="icon-video" onClick={e => setPlay(true)} />
                                </strong>
                            </div>}
                            {(hit.virtual_tour && isPlay) && 
                                <div className="video-container">
                                    <YouTube
                                        className="video-inline"
                                        videoId={hit.virtual_tour.split("v=").length > 1 ? hit.virtual_tour.split("v=")[1] : hit.virtual_tour.split("youtu.be/")[1]}
                                        opts={{
                                            height: "100%",
                                            width: "100%",
                                            playerVars: {
                                                autoplay: 1,
                                                disablekb: 1
                                            }
                                        }}
                                        onEnd={() => setPlay(false)}
                                        onError={(err) => {
                                            console.log(err)
                                            setPlay(false)
                                        }}
                                    />
                                    <div className="btn btn-light close-icon" onClick={() => setPlay(false)}>
                                        <img src={closeIcon} alt="close-icon"/>
                                    </div>
                                </div>
                            }
                            <button className="prop-card-btn">{hit.status}</button>
                        </div>
                    </Col>
                    <Col xl={6} className="pr-xl-0">
                        <div className="product-card-details">
                            <h2>
                                <Link to={`/property-${hit.searchType === "sales" ? "for-sale" : "to-rent"}/${hit.slug}-${props.strapi ? hit.id : hit.objectID}`}>
                                    {hit.display_address}
                                </Link>
                            </h2>
                            <span className="sm-content">
                                {hit?.title}
                            </span>
                            {/* <span className="price-list">
                                {hit?.price_qualifier} {hit?.price_qualifier !== "Price on Application" ? "£ " + hit?.price.toLocaleString() : ""} {hit.searchType === "lettings" ? "PCM" : ""}
                            </span> */}
                            <span className="price-list">
                                 {hit?.price_qualifier !== "Price on Application" ? "£ " + hit?.price.toLocaleString() : ""} {hit.searchType === "lettings" ? "PCM" : ""}
                            </span>
                            <div className="product-icon">
                                <span className="details">
                                    <i className="icon-bed-room d-md-none"></i>
                                    <span className="quantity">{hit.bedroom}</span>
                                    <span className="title d-none d-md-block">Bedrooms</span>
                                </span>
                                <span className="details">
                                    <i className="icon-bath-room d-md-none"></i>
                                    <span className="quantity">{hit.bathroom}</span>
                                    <span className="title d-none d-md-block">Bathrooms</span>
                                </span>
                                <span className="details rm-border">
                                    <i className="icon-reception d-md-none"></i>
                                    <span className="quantity">{hit.reception}</span>
                                    <span className="title d-none d-md-block">Receptions</span>
                                </span>
                                {/* <span className="sm-text d-none d-md-block">Private Gated Development</span> */}
                            </div>
                            <div>
                                <p>
                                    <Truncate lines={4}>
                                    {hit?.description}
                                    </Truncate>
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}   

const PropertyCard = (props) => {
    const { hits,  hasPrevious, refinePrevious, hasMore, refineNext, location } = props;
    return (
        <React.Fragment>
            {hits.map((hit, i) => 
                <React.Fragment key={i}>
                    {(i % 6 == 0 && i !== 0) && <div className="property-card px-lg-3 px-0"><SellProduct title="Are you ready to Sell or Let your property?"  link="book-a-valuation" class="mb-5"/></div>}
                    <SingleProperty hit={hit} key={i} location={location}/>
                </React.Fragment>
            )}
            {(hits.length > 0 && hasMore) && (
                <Col lg={12} className="d-flex justify-content-center py-5">
                    <button
                        id="mynextbut"
                        onClick={refineNext}
                        disabled={!hasMore}
                        className="btn property-search-load-more"
                    >
                        Show more
                    </button>
                </Col>
        )}
        </React.Fragment>
    )
}
export default PropertyCard
